import React, { use, useState } from 'react'

import { AnimatePresence, motion, usePresence } from 'framer-motion'
import Cookies from 'js-cookie'
import { CloseIcon } from '@chakra-ui/icons'
import { Box, Button, IconButton, Text } from '@chakra-ui/react'

import { HeaderContext } from '@/context/Header'
import { useTeam } from '@/react-query/team'
import { useUser } from '@/react-query/user'

export const ReferralBanner: React.FC = () => {
  const user = useUser()
  const cookieName = `isBannerClosed-${user.data?.email}`
  const [isShown, setIsShown] = useState(!Cookies.get(cookieName))
  const { referralModalDisclosure } = use(HeaderContext)

  const [isPresent, safeToRemove] = usePresence()

  const team = useTeam()

  const handleClose: React.MouseEventHandler<HTMLButtonElement> = () => {
    Cookies.set(cookieName, 'true', { expires: 14 })
    setIsShown(false)
  }
  return (
    <AnimatePresence mode="wait">
      {!team.data?.id && isShown ? (
        <motion.div
          key={'banner'}
          layout={true}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{
            opacity: 0,
            transition: {
              ease: 'linear',
            },
          }}
          onAnimationComplete={() => !isPresent && safeToRemove()}
          className="flex py-3 items-center px-5 md:px-12 relative"
        >
          <Box className="flex-grow flex justify-center items-center mr-1">
            <Text fontWeight={'bold'} color={'rgba(0, 0, 0, 0.5)'}>
              Refer a friend and get an extra month for free
            </Text>
            <Button
              variant="brand-blue"
              className="shrink-0"
              marginLeft={'0.7rem'}
              onClick={(e) => {
                e.stopPropagation()
                referralModalDisclosure.onOpen()
              }}
            >
              Wow, cool!
            </Button>
          </Box>

          <IconButton
            variant={'ghost'}
            rounded={'full'}
            colorScheme="blackAlpha"
            color={'black'}
            aria-label={'Close banner'}
            icon={<CloseIcon />}
            className="ml-auto"
            onClick={handleClose}
          />
        </motion.div>
      ) : null}
    </AnimatePresence>
  )
}
